import { ApiService } from '../../services/api.service';
import { TemplateService } from '../../services/template.service';
import { ActivatedRoute } from '@angular/router';
import { CALENDAR_LOCALE } from '../../services/constant';
import * as moment from 'moment';
var SaleTaxComponent = (function () {
    function SaleTaxComponent(apiService, template, route) {
        this.apiService = apiService;
        this.template = template;
        this.route = route;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.selectedMonth = new Date(moment().format('YYYY') + '-01-01');
        this.searchInput = '';
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.currentPage = 1;
        this.loading = false;
        this.selectedMonthLabel = moment().format('MM/YYYY');
    }
    SaleTaxComponent.prototype.ngOnInit = function () { };
    SaleTaxComponent.prototype.search = function () { };
    SaleTaxComponent.prototype.clearData = function () { };
    SaleTaxComponent.prototype.getSelectedMonth = function (e) {
        this.selectedMonth = new Date(moment(e).format('YYYY-MM') + '-01');
        this.selectedMonthLabel = moment(e).format('MM/YYYY');
    };
    return SaleTaxComponent;
}());
export { SaleTaxComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.component.ts.pre-build-optimizer.js